<script lang="ts">
    /**
 *
 *
 */
    interface Props {
        src: string;
    }

    let { src }: Props = $props();

    /*                                     */
    const esiInclude = `<esi:include src="${src}" onerror="continue" />`;
</script>

{#key src}
    <!-- eslint-disable-next-line svelte/no-at-html-tags -->
    {@html esiInclude}
{/key}
